import { cn } from '../lib/cva'

export const Spinner = ({ className }: { className?: string }) => (
	<output
		className={cn(
			'animate-spin inline-block size-8 border-3 border-current border-t-transparent text-primary-600 rounded-full',
			className,
		)}
		aria-label='loading'
	/>
)

export const SpinnerWithBackground = ({
	spinnerClass,
	backgroundClass,
}: {
	spinnerClass?: string
	backgroundClass?: string
}) => (
	<div className='absolute inset-0 flex items-center justify-center z-10'>
		<div className={cn('absolute bg-white opacity-70 w-full h-full', backgroundClass)} />
		<Spinner className={cn('fill-primary-600', spinnerClass)} />
	</div>
)
